import React from 'react';
import { User, Mail, Globe, Smartphone } from 'lucide-react';

interface AccountInfoTabProps {
    user: any;
}

const AccountInfoTab: React.FC<AccountInfoTabProps> = ({ user }) => {
    return (
        <div className="space-y-8">
            <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Hesap Bilgileri</h3>
                <p className="text-gray-600">
                    Temel hesap bilgileriniz ve profil ayarlarınız
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Ad</label>
                    <div className="flex items-center p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <User className="h-5 w-5 text-gray-400 mr-3" />
                        <span className="text-gray-900">{user?.first_name || 'Belirtilmemiş'}</span>
                    </div>
                </div>
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Soyad</label>
                    <div className="flex items-center p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <User className="h-5 w-5 text-gray-400 mr-3" />
                        <span className="text-gray-900">{user?.last_name || 'Belirtilmemiş'}</span>
                    </div>
                </div>
                <div className="space-y-2 md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700">Email</label>
                    <div className="flex items-center p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <Mail className="h-5 w-5 text-gray-400 mr-3" />
                        <span className="text-gray-900">{user?.email}</span>
                    </div>
                </div>
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Üyelik Tarihi</label>
                    <div className="flex items-center p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <Globe className="h-5 w-5 text-gray-400 mr-3" />
                        <span className="text-gray-900">
                            {user?.created_at ? new Date(user.created_at).toLocaleDateString('tr-TR') : 'Bilinmiyor'}
                        </span>
                    </div>
                </div>
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Son Giriş</label>
                    <div className="flex items-center p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <Smartphone className="h-5 w-5 text-gray-400 mr-3" />
                        <span className="text-gray-900">
                            {user?.last_login ? new Date(user.last_login).toLocaleDateString('tr-TR') : 'Bilinmiyor'}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountInfoTab;
